import { z } from "zod/v4";

export const OneClickUpsellGlobalSettingsDtoSchema = z.object({});

export type OneClickUpsellGlobalSettingsDto = z.infer<
  typeof OneClickUpsellGlobalSettingsDtoSchema
>;
export type OneClickUpsellExperienceSettingsDto = object;
